const breakpoints = {
  base: "0em",
  md: "48em",
  xl: "80em",
};

export default breakpoints;
